var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelievedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 58.4C41.8042 58.4 53.4 46.8042 53.4 32.5C53.4 18.1958 41.8042 6.6 27.5 6.6C13.1958 6.6 1.6 18.1958 1.6 32.5C1.6 46.8042 13.1958 58.4 27.5 58.4Z",
    fill: "#EBF3FF",
    stroke: "#EBF3FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 29.1672C15.834 30.0513 16.1852 30.8991 16.8103 31.5243C17.4354 32.1494 18.2833 32.5006 19.1673 32.5006C20.0514 32.5006 20.8992 32.1494 21.5243 31.5243C22.1495 30.8991 22.5007 30.0513 22.5007 29.1672M32.5007 29.1672C32.5007 30.0513 32.8518 30.8991 33.477 31.5243C34.1021 32.1494 34.9499 32.5006 35.834 32.5006C36.718 32.5006 37.5659 32.1494 38.191 31.5243C38.8161 30.8991 39.1673 30.0513 39.1673 29.1672",
    stroke: "#001F4B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.001 40.2253C32.7074 42.3002 30.1146 43.3714 27.4822 43.3318C24.8497 43.2922 22.2699 42.1431 20.001 39.9995",
    stroke: "#001F4B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 25.0002C39.2534 23.8272 38.124 22.0592 34.999 22.6008",
    stroke: "#001F4B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 25.0002C16.5786 23.8272 17.708 22.0592 20.833 22.6008",
    stroke: "#001F4B",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelievedLight);
export default __webpack_public_path__ + "static/media/relieved-light.8c5143a8.svg";
export { ForwardRef as ReactComponent };